import { State } from './home.store';
import { ActionTree, Commit, Dispatch, MutationTree } from 'vuex';
import * as types from '../apm/mutation-types';
import { initState } from '@/store/modules/home/home.store';

const mutations: MutationTree<State> = {
  [types.SET_APPLICATION_META](state: State, data: any): void {
    state.applicationData = data.records;
    state.applicationDataTotal = data.total;
  },
  [types.SET_MOBILE_META](state: State, data: any): void {
    state.mobilerData = data.records;
    state.mobileDataTotal = data.total;
  },
  [types.SET_BROWSER_META](state: State, data: any): void {
    state.browserData = data.records;
    state.browserDataTotal = data.total;
  },
  [types.SET_ENDPOINT_META](state: State, data: any): void {
    state.endpointData = data.records;
    state.endpointDataTotal = data.total;
  },
  [types.SET_RECENT_ALERTS](state: State, data: any): void {
    state.recentAlert = data;
  },
  [types.SET_CONFIGURED_ALERT](state: State, data: any): void {
    state.configuredAlert = data;
  },
  [types.SET_ID](state: State, data: any) {
    state.serviceId = data;
  },
  setdeleteWidgetId(state: State, data: any) {
    state.deleteWidgetId = data;
  },
  setSelectedWidgetId(state: State, data: any) {
    state.selectedWidgetId = data;
  },
  setDefaultDashboard(state: State, data: any) {
    state.defaultDashBoard = data;
  },
  setSelectedDashboard(state: State, data: any) {
    state.selectedDashboard = data;
  },
  [types.SET_APP_SPAN_VIEW](state: State, data: any) {
    state.applicationSpanOpen = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initState });
  },
};

export default mutations;
